import { lazy, Suspense } from 'react';
import { useToast } from '@/components/ui/use-toast';

const ToastRenderer = lazy(() => import('@/components/ui/toaster').then(module => ({ default: module.Toaster })));

export default function OnDemandToaster() {
  // Messages stay in the existing shared store while the renderer downloads.
  const { toasts } = useToast();
  return toasts.length ? <Suspense fallback={null}><ToastRenderer /></Suspense> : null;
}